<template>
  <div class="withdraw_index">
    <div class="withdraw_index_nav">
      <navbar
        title="发起提现"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row class="accout">
        <van-col span="24" class="title">提现账户</van-col>
        <!-- <van-col span="24" class="tip">
          对公账户提现仅在每月的1号-7号可以使用，敬请谅解
          </van-col> -->
        <!-- <van-col span="24" class="item">
          <img
            class="icon"
            src="@/assets/purchaseSupplier/withdraw/balance.png"
          />
          余额账户({{ xb_account }})
        </van-col> -->
        <van-col span="24" class="item">
          <img class="icon" src="@/assets/purchaseSupplier/withdraw/bank.png" />
          <p class="bank_name">{{ withdraw_info.account_bank }}</p>
          <p class="bank_number">{{ withdraw_info.account_number }}</p>
           <img
            v-show="accountType != 1"
            @click="changeAccount(1)"
            src="@/assets/purchaseSupplier/common/no_select.png"
          />
          <!-- <img
            v-show="accountType != 1 && bankCanUsed"
            @click="changeAccount(1)"
            src="@/assets/purchaseSupplier/common/no_select.png"
          />
          <img
            v-show="!bankCanUsed"
            src="@/assets/purchaseSupplier/withdraw/can_not_select.png"
          /> -->
          <img
            v-show="accountType == 1"
            src="@/assets/purchaseSupplier/withdraw/selected.png"
          />
        </van-col>
        <van-col
          span="24"
          class="item"
          v-if="withdraw_info.alipay_account_number"
        >
          <img
            class="icon"
            src="@/assets/purchaseSupplier/withdraw/alipay_icon.png"
          />
          <p class="bank_name">企业支付宝</p>
          <p class="bank_number">{{ withdraw_info.alipay_account_number }}</p>
          <img
            v-show="accountType != 2"
            @click="changeAccount(2)"
            src="@/assets/purchaseSupplier/common/no_select.png"
          />
          <img
            v-show="accountType == 2"
            src="@/assets/purchaseSupplier/withdraw/selected.png"
          />
        </van-col>
      </van-row>
      <!-- <van-row class="accout second">
        <van-col span="24" class="title">提现金额</van-col>
        <van-col span="24" class="money">
          <span class="label">￥</span>
          <span class="all" @click="allWithdraw">全部</span>
          <van-cell-group>
            <van-field
              class="withdrawNum"
              v-model="value"
              :formatter="formatter"
              type="number"
              pattern="number"
            />
          </van-cell-group>
        </van-col>
        <van-col span="24" class="tips">可提现总额：{{ money }}元</van-col>
      </van-row> -->
      <!-- <van-row class="accout third">
        <van-col span="24" class="title">手机验证</van-col>
        <van-col span="24" class="phone"
          >手机号 <span>17788889999</span></van-col
        >
        <van-col span="24" class="veri">
          <van-cell-group>
            <van-field v-model="sms" center label="验证码" placeholder="请输入">
              <template #button>
                <span class="van-button">获取验证码</span>
              </template>
            </van-field>
          </van-cell-group>
        </van-col>
      </van-row> -->
      <van-row class="accout four">
        <van-col span="24" class="title"
          >关联提现订单
          <van-icon class="bind_icon" name="question-o" @click="bindTip" />
          <btn
            class="btn_bind"
            :btntext="'选择提现订单 >'"
            :btnwidth="'10.4rem'"
            :height="'3rem'"
            :bgcolor="
              selectedOrder
                ? '#D2D2D2'
                : 'linear-gradient(to right, #FC740C, #F41A3C)'
            "
            :borderradius="'1.5rem'"
            :btncolor="'#fff'"
            :fontsize="'1.2rem'"
            @btnClick="toBind"
          />
        </van-col>
        <van-col span="24" class="bind_order">
          <img
            v-show="!selectedOrder"
            src="@/assets/purchaseSupplier/withdraw/no_bind_order.png"
          />
          <img
            v-show="selectedOrder"
            src="@/assets/purchaseSupplier/withdraw/bind_order.png"
          />
          <span class="status1" v-show="!selectedOrder">暂无关联订单</span>
          <span class="status2" v-show="selectedOrder" @click="selectedOrders"
            >提现金额：¥{{ selectedOrderInfo.orderMoney }}</span
          >
          <van-icon
            name="clear"
            v-show="selectedOrder"
            @click="delectBindedOrder"
          />
        </van-col>
      </van-row>
      <van-row class="explain">
        <van-col span="24" class="title">提现说明</van-col>
        <van-col span="24" class="con">
          <p>1、提现到企业支付宝</p>
          <p>提现次数不限，单次提现金额需≥1元。提现申请将在3个工作日内处理。</p>
        </van-col>
        <van-col span="24" class="con">
          <p>2、提现到对公银行卡</p>
          <p>
           提现次数不限，单次提现金额需要≥1元，提现申请将在7个工作日内处理。
          </p>
        </van-col>
        <!-- <van-col span="24" class="con">
          <p>3、发票</p>
          <p>提现后需提供发票，发票每月汇总提供一次。</p>
        </van-col> -->
      </van-row>
      <btn
        class="btns"
        :btntext="'生成提现记录'"
        :btnwidth="'34.3rem'"
        :height="'4.4rem'"
        :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
        :borderradius="'2.2rem'"
        :btncolor="'#fff'"
        :fontsize="'1.6rem'"
        @btnClick="confirm1"
      />
    </div>

    <!-- <van-popup class="showPopup" v-model="showPopup" position="bottom">
      <p class="popup_title">
        <img
          class="icon"
          v-show="!isMask"
          @click="changeStatus"
          src="@/assets/purchaseSupplier/withdraw/openEye.png"
        />
        <img
          class="icon"
          v-show="isMask"
          @click="changeStatus"
          src="@/assets/purchaseSupplier/withdraw/closeEye.png"
        />
        验证支付密码
        <img
          class="close"
          @click="closePopup"
          src="@/assets/purchaseSupplier/withdraw/close.png"
        />
      </p>
      <van-password-input
        :value="passWord"
        :focused="showKeyboard"
        :gutter="6"
        :mask="isMask"
        @focus="showKeyboard = true"
      />
      <p class="tips" @click="forgetPassWord">
        <span>忘记密码</span>
      </p>
      <van-number-keyboard
        v-model="passWord"
        :show="showKeyboard"
        @blur="showKeyboard = false"
      />
    </van-popup> -->
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      // value: "",
      accountType: 0,
      // showPopup: false,
      // passWord: "",
      // showKeyboard: true,
      isMask: true,
      money: "",
      isset: "",
      // xb_account: "",
      withdraw_info: {},
      // bankCanUsed: true,
      selectedOrder: false,
      selectedOrderInfo: {},
    };
  },
  created() {
    this.withdraw_info = JSON.parse(localStorage.getItem("withdraw_info"));
    this.isset = this.withdraw_info.isset;
    // this.xb_account = this.$route.query.xb_account;
    this.money = this.withdraw_info.with_drawable_cash || "0.00";

    let Type = localStorage.getItem("accountType");
    if (Type) {
      this.accountType = Type;
      localStorage.removeItem("accountType");
    } else if (this.withdraw_info.account_number) {
      this.accountType = 1;
    }else if (this.withdraw_info.alipay_account_number) {
      this.accountType = 2;
    }
    // if (Number(new Date().getDate()) > 7) {
    //   this.bankCanUsed = false;
    // }
    if (localStorage.getItem("selectedOrderInfo")) {
      this.selectedOrder = true;
      this.selectedOrderInfo = JSON.parse(
        localStorage.getItem("selectedOrderInfo")
      );
      localStorage.removeItem("selectedOrderInfo");
    }
  },
  watch: {
    passWord(value) {
      if (value.length === 6) {
        this.showPopup = false;
        this.submit(); //提交
      }
    },
  },
  mounted() {
    // document.querySelector(".withdrawNum input").click();
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    // document.querySelector(".money input").focus();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    changeAccount(index) {
      this.accountType = index;
    },
    bindTip() {
      this.$dialog
        .confirm({
          message:
            "只能生成一个关联的提现订单记录，删除现有关联的提现订单才能重新上传",
          confirmButtonText: "我知道了",
          confirmButtonColor: "#F9591B",
          showCancelButton: false,
        })
        .then(() => {
          // on confirm
        });
    },
    toBind() {
      if (this.selectedOrder) {
        return;
      }
      localStorage.setItem("accountType", this.accountType);
      this.$router.push({
        path: "/purchaseSupplier/bindOrder",
        query: {
          supplier_number: this.$route.query.supplier_number,
        },
      });
    },
    delectBindedOrder() {
      this.$dialog
        .confirm({
          message: "确定删除此条关联的提现订单记录吗？",
          confirmButtonText: "确认操作",
          confirmButtonColor: "#F9591B",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          this.selectedOrder = false;
          localStorage.removeItem("selectedOrderInfo");
        });
    },
    confirm1() {
      if (this.accountType == 0) {
        this.$toast("请选择提现账户");
        return;
      } else if (!this.selectedOrder) {
        this.$dialog
          .confirm({
            message: "请先关联提现订单",
            confirmButtonText: "确认",
            confirmButtonColor: "#F9591B",
            showCancelButton: false,
          })
          .then(() => {
            // on confirm
          });
      } else {
        // 生成提现记录
        this.$api
          .post(
            "member-relation/member/supplier/withdrawal/create-withdrawal",
            {
              supplier_id: this.$route.query.id,
              type: this.accountType == 1 ? 4 : 5,
              balance: this.selectedOrderInfo.orderMoney,
              order_ids_group: this.selectedOrderInfo.orderIds,
            }
          )
          .then((res) => {
            localStorage.removeItem("selectAddress");
            // 供应方提现优化需求，产品要求详情样式统一展示 2022-02-14
            this.$router.replace({
              path: "/purchaseSupplier/withdrawDetail",
              query: {
                recordId: res.id,
                id: this.$route.query.id,
                from: "withdraw",
              },
            });
          })
          .catch((err) => {
            this.passWord = "";
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
            return;
          });
      }
    },
    selectedOrders() {
      localStorage.setItem(
        "selectedOrderInfo",
        JSON.stringify(this.selectedOrderInfo)
      );
      this.$router.push({
        path: "/purchaseSupplier/bindedOrder",
        query: this.selectedOrderInfo,
      });
    },

    // 以下事件废弃
    // allWithdraw() {
    //   this.value = this.money;
    // },
    // changeStatus() {
    //   this.isMask = !this.isMask;
    // },
    // closePopup() {
    //   this.showPopup = false;
    //   this.passWord = "";
    // },
    // formatter(value) {
    //   // 过滤输入的数字
    //   return value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
    // },
    // confirm() {
    //   if (this.accountType == 0) {
    //     this.$toast("请选择提现账户");
    //     return;
    //   } else if (!this.value) {
    //     this.$toast("请输入提现金额");
    //     return;
    //   } else if (Number(this.value) > Number(this.money)) {
    //     this.$toast("提现金额不能大于可提现金额");
    //     return;
    //   } else {
    //     if (this.isset == 1) {
    //       this.showPopup = true;
    //     } else {
    //       this.showTips();
    //     }
    //   }
    // },
    // submit() {
    //   this.$api
    //     .post("member-relation/member/supplier/withdrawal/apply", {
    //       supplier_id: this.$route.query.id,
    //       type: this.accountType == 1 ? 4 : 5,
    //       balance: this.value,
    //       password: this.passWord,
    //     })
    //     .then((res) => {
    //       localStorage.removeItem("selectAddress");
    //       //accountType == 2
    //       let routerPath = "";
    //       if (this.accountType == 1) {
    //         routerPath = "/purchaseSupplier/withdrawDetail";
    //       } else {
    //         routerPath = "/purchaseSupplier/alipayWithdrawDetail";
    //       }
    //       this.$router.replace({
    //         path: routerPath,
    //         query: {
    //           id: res.id,
    //           shopId: this.$route.query.id,
    //           from: "withdraw",
    //         },
    //       });
    //     })
    //     .catch((err) => {
    //       this.passWord = "";
    //       let keys = Object.keys(err);
    //       let key = keys[0];
    //       let message = err.message || err[key][0];
    //       if (message.slice(0, 10) == "timeout of") {
    //         this.$toast("网络不给力，请稍候重试");
    //       } else {
    //         this.$toast(message);
    //       }
    //       return;
    //     });
    // },
    // showTips() {
    //   this.$dialog
    //     .confirm({
    //       title: "温馨提示",
    //       message: "您还未设置支付密码，为了您的账号安全，请先前往设置支付密码",
    //       confirmButtonText: "设置",
    //       confirmButtonColor: "#F9591B",
    //       cancelButtonText: "取消",
    //       cancelButtonColor: "#333",
    //     })
    //     .then(() => {
    //       // on confirm
    //       this.params("", "", "setPassWord");
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
    // },
    // forgetPassWord() {
    //   this.params("", "", "forgetPassWord");
    // },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.withdraw_index {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .withdraw_index_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    padding: 10.4rem 1.6rem 6rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .accout {
      min-height: 12.7rem;
      padding: 1.2rem 2rem 2.1rem;
      background: #fff;
      border-radius: 0.8rem;
      box-sizing: border-box;
      margin-bottom: 1.2rem;

      .title {
        color: #333;
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 2rem;
      }

      .tip {
        // color: #fb6b10;
        // font-size: 1.2rem;
        // line-height: 1.7rem;
        // padding: 1rem 0.9rem 0.9rem;
        // background: rgba(252, 115, 12, 0.05);
        // border-radius: 0.5rem;
        // margin: 1rem 0 1.2rem;
        height: 2.2rem;
      }

      .item {
        height: 3.6rem;
        // line-height: 4.4rem;
        color: #333;
        font-size: 1.4rem;
        margin-top: 2.6rem;

        img {
          width: 2rem;
          float: right;
          margin-top: -2.8rem;
        }

        .icon {
          width: 3.4rem;
          float: left;
          margin: 0.1rem 1.2rem 0 0;
        }

        .bank_name {
          font-size: 1.4rem;
          height: 2rem;
          line-height: 2rem;
        }

        .bank_number {
          font-size: 1.2rem;
          height: 1.6rem;
          line-height: 1.6rem;
          color: #999;
        }
      }


      .money {
        height: 5.9rem;
        overflow: hidden;
        position: relative;

        .van-cell-group {
          height: 6rem;
          line-height: 6rem;
          margin-top: -0.1rem;

          .van-cell {
            padding: 1.1rem 1.4rem;
            height: 5.9rem;

            /deep/.van-field__body {
              height: 3.7rem;
              line-height: 3.7rem;
              color: #333;
              font-size: 3.2rem;
              font-weight: 700;
            }
          }
        }

        .label {
          position: absolute;
          bottom: 1.2rem;
          left: -0.4rem;
          z-index: 9;
          color: #333;
          font-size: 1.8rem;
          font-weight: 700;
          line-height: 2.5rem;
        }

        .all {
          position: absolute;
          bottom: 1.2rem;
          right: 0;
          z-index: 9;
          line-height: 2rem;
          color: #5d79bb;
          font-size: 1.4rem;
        }
      }

      .tips {
        color: #999;
        font-size: 1.2rem;
        line-height: 1.7rem;
        margin-top: 0.7rem;
      }

      .phone {
        color: #333;
        font-size: 1.4rem;
        line-height: 2rem;
        margin-bottom: 0.8rem;

        span {
          margin-left: 1.6rem;
        }
      }

      .veri {
        height: 4.4rem;
        overflow: hidden;

        .van-cell-group {
          height: 4.7rem;
          margin-top: -0.2rem;

          .van-cell {
            padding: 0;
            height: 4.4rem;
            line-height: 4.4rem;

            /deep/.van-field__label {
              width: 5.8rem;
              margin: 0;
            }

            /deep/.van-field__body {
              height: 4.3rem;
              line-height: 4.4rem;
              color: #333;
              font-size: 1.7rem;
              border-bottom: solid 0.05rem #ccc;

              .van-field__button {
                height: 4.4rem;

                .van-button {
                  line-height: 4.4rem;
                  color: #5d79bb;
                  float: right;
                  border: none;
                  border-bottom: solid 0.05rem #ccc;
                }

                .van-button::before {
                  background: #fff;
                }
              }
            }
          }
        }
      }
    }

    .second {
      min-height: 15.3rem;

      .title {
        margin-bottom: 1.3rem;
      }
    }

    .third {
      min-height: 15.7rem;

      .title {
        margin-bottom: 2.4rem;
      }
    }

    .four {
      height: 12rem;
      padding: 1.9rem 1.4rem 1.6rem 2.2rem;

      .title {
        position: relative;

        .btn_bind {
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      .bind_order {
        line-height: 4.5rem;
        color: #999;
        font-size: 1.6rem;
        background: #f5f6f7;
        border-radius: 0.5rem;
        padding: 0 1.2rem;
        margin-top: 2rem;

        img {
          width: 1.8rem;
          margin-right: 1rem;
          vertical-align: middle;
        }

        .van-icon {
          width: 1.8rem;
          color: #999;
          float: right;
          margin-top: 1.3rem;
        }

        .status2 {
          color: #4988fd;
          font-size: 1.6rem;
          border-bottom: solid 1px #4988fd;
        }
      }
    }

    .explain {
      .van-col {
        color: #999;
        font-size: 1.2rem;
        line-height: 1.7rem;
        margin-bottom: 2rem;
      }

      .title {
        color: #333;
        font-size: 1.4rem;
        line-height: 2rem;
        margin: 0.8rem 0 1.2rem;
      }
    }

    .btns {
      position: fixed;
      bottom: 0.4rem;
      left: 1.6rem;
    }
  }

  .showPopup {
    min-height: 387px;

    .popup_title {
      text-align: center;
      color: #333;
      font-size: 16px;
      padding: 0 13px;
      line-height: 56px;

      .icon {
        width: 20px;
        margin-right: 6px;
        vertical-align: middle;
      }

      .close {
        width: 22px;
        float: right;
        margin-top: 17px;
      }
    }

    .tips {
      height: 36px;
      padding: 9px 19px;
      box-sizing: border-box;

      span {
        color: #999;
        font-size: 12px;
        line-height: 19px;
        float: right;
      }
    }

    .van-password-input__item {
      border: solid 1px #e5e5e5;
      border-radius: 5px;
    }

    .van-password-input__item--focus {
      border-color: #f9591b;

      .van-password-input__cursor {
        background-color: #f9591b;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.van-dialog {
  border-radius: 2.5rem;
  height: 19.7rem;
  width: 29.6rem;

  .van-dialog__header {
    color: #333;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.2rem;
    margin: 4rem 0 1.6rem;
    padding: 0;
  }

  .van-hairline--top::after {
    border: none;
  }

  .van-dialog__footer {
    display: block;
    border: none;
    box-shadow: none;
    padding: 0 1.6rem;

    .van-dialog__cancel {
      color: #333;
      width: 11.9rem;
      height: 3.6rem;
      font-size: 1.4rem;
      border: solid 1px #eee;
      border-radius: 1.8rem;
    }

    .van-dialog__confirm {
      float: right;
      color: #fff;
      width: 11.9rem;
      height: 3.6rem;
      font-size: 1.4rem;
      border-radius: 1.8rem;
      background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
      /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to right, #fc740c, #f41a3c);
      /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
      /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #fc740c, #f41a3c);
    }
  }

  .van-dialog__content {
    min-height: 6.3rem;
    .van-dialog__message {
      padding: 0 1rem !important;
      color: #333;
      font-weight: 700;
      font-size: 1.4rem;
      line-height: 2rem;
    }

    .van-dialog__message--has-title {
      padding: 0;
      color: #333;
    }
  }
}
</style>


